import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

@Component({
  selector: 'vcr-outlet',
  template: '<ng-container #anchor></ng-container>'
})
export class VcrOutletComponent implements OnInit {
  @ViewChild('anchor', { read: ViewContainerRef, static: true })
  anchor!: ViewContainerRef;

  @Output() ready = new EventEmitter<ViewContainerRef>();

  ngOnInit() {
    this.ready.emit(this.anchor);
  }
}